import React, { useEffect, useState, useContext  } from "react"
import Flatpickr from "react-flatpickr";

import {
  Col,
  Row,
  Card,
  CardBody,
  Container,
  Label,
  Input,
  InputGroup,
  Form,
  FormFeedback,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
  Spinner,
  CardFooter
} from "reactstrap"

import Select from "react-select"
import CreatableSelect from "react-select/creatable"

import { Editor } from "@tinymce/tinymce-react"

import classnames from "classnames"

import { checkScope } from "helpers/utility_helper"

// Formik Validation
import * as Yup from "yup"
import { useFormik, FieldArray, FormikProvider } from "formik";

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb2"
import { withTranslation } from "react-i18next"
import "../../components/Common/ts-css.css"
import { Link, useNavigate, useParams } from "react-router-dom"
import _ from "lodash"
import fn_helper from "helpers/fn_helper"
import { CreateFooter, GetFooterById, UpdateFooter } from "services/api/module/Footer"
import ModalContext from "../../contexts/ModalContext";
import UploadFileAPI from "components/UploadFileAPI"
import InputLang from "components/Input/InputLang";
import moment from "moment";
import MyEditor from "components/MyEditor";
import UploadFileS3 from "components/UploadFileS3";
import InputAttachment from "components/Input/attachment/InputAttachment";
import PopupAttachment from "components/Input/attachment/PopupAttachment";
import UploadDesc from "components/UploadDesc";
import { ReactSortable } from 'react-sortablejs';
import Sortable from "sortablejs"
import Error401 from "components/Error401";

const STATUS_OPTION = fn_helper.OPTIONS.STATUS_NO_DELETE
const _routePermission = `footer`

const FooterTemplate = ({
  pageView = "create"
}) => {
  // POPUP
  const { mAlert } = useContext(ModalContext);

  // OTHER STATE
  const qParams = useParams()
  const qLang = _.upperCase(qParams?.lang) ?? 'TH'
  const qMainId = 1
  const navigate = useNavigate();

  const [list, setList] = useState([
    { id: 1, name: 'Item 1' },
    { id: 2, name: 'Item 2' },
    { id: 3, name: 'Item 3' },
    { id: 4, name: 'Item 4' }
  ]);

  // ========== Form Validation ========== //
  const validationSchema = Yup.object({
    contentCompanyAddress: Yup.string().max(1024).required("Please Enter Company Address"),
    contentSectionLink1: Yup.string().max(1024).required("Please Enter Section Link 1"),
    contentSectionLink2: Yup.string().max(1024).required("Please Enter Section Link 2"),
    contentSectionLink3: Yup.string().max(1024).required("Please Enter Discover more"),
    contentUpdateDate: Yup.string().max(100).required("Please Select Written at"),
    contentStatus: Yup.string().max(100).required("Please Enter Display"),

    // socialLink: Yup.array()

  })
  

  // LOCAL STATE FORM
  const [updatedValidationSchema, setUpdatedValidationSchema] = useState(validationSchema)

  const initialValues = {
    contentId: "",

    // Content
    contentCompanyAddress: "",
    contentSectionLink1: "",
    contentSectionLink2: "",
    contentSectionLink3: "",

    socialLink: [],
    contentUpdateDate: moment().format('YYYY-MM-DD'),
    contentStatus: "active",


  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: updatedValidationSchema,
    onSubmit: values => {
      console.log("🚀 ~ FooterCreate ~ values:", values)
      const payload = {
        id: qMainId ? qMainId : undefined,
        contentId: values.contentId ? values.contentId: undefined,
        langId: qLang,
        contentCompanyAddress: values.contentCompanyAddress,
        contentSectionLink1: values.contentSectionLink1,
        contentSectionLink2: values.contentSectionLink2,
        contentSectionLink3: values.contentSectionLink3,

        contentUpdateDate: values.contentUpdateDate,
        contentStatus: "active",

        attachmentData: {
          
        },

        contentAttachmentData: {
          socialLink: values.socialLink,
        }
      };
      console.log("🚀 ~ onSave ~ payload:", payload);

      if (pageView === "update") {
        API.fetchUpdateFooter(payload)
      } else {
        API.fetchCreateFooter(payload)
      }
    },
  })

  const preFilInput = (resData = {}) => {
    console.log("🚀 ~ preFilInput ~ resData:", resData)
    // resetForm(validation.values, initialValues)

    // ถ้าไม่หน่วงมันจะแย่งกันทำ
    validation.setFieldValue("contentId", resData?.contentId ?? "")
    validation.setFieldValue("contentCompanyAddress", resData?.contentCompanyAddress ?? "")
    validation.setFieldValue("contentSectionLink1", resData?.contentSectionLink1 ?? "")
    validation.setFieldValue("contentSectionLink2", resData?.contentSectionLink2 ?? "")
    validation.setFieldValue("contentSectionLink3", resData?.contentSectionLink3 ?? "")
    validation.setFieldValue("socialLink", resData?.contentSocialLink ?? [])

    validation.setFieldValue("contentUpdateDate", resData?.contentUpdateDate ?? moment().format('YYYY-MM-DD'))
    validation.setFieldValue("contentStatus", resData?.contentStatus ?? "active")

  }

  const API = {
    fetchGetFooterById: async (payload) => {
      try {
          const response = await GetFooterById({ id: payload.id, lang: qLang })
          const resData = response.data
          if (resData.status == 200) {
            preFilInput(resData.data)
          }
      }
      catch (err) {
          console.log('err ', err)
          mAlert.info({
            title: "Alert",
            subTitle: "Something went wrong",
            content: "",
            onClose: () => {
            //  alert("onClose")
            },
        })
      }
    },
    fetchCreateFooter: async (payload) => {
      try {
          const response = await CreateFooter({ data: payload, lang: qLang })
          const resData = response.data
          if (resData.status == 201) {
            mAlert.info({
                title: "Alert",
                subTitle: "Created Data Success",
                content: "",
                onClose: () => {
                  // navigate(`/footer/${qLang}`)
                },
            })
          }
      } catch (e) {
          console.log(e)
          mAlert.info({
              title: "Alert",
              subTitle: "Something went wrong",
              content: "",
              onClose: () => {
              //  alert("onClose")
              },
          })
      }
    },
    fetchUpdateFooter: async (payload) => {
      try {
          const response = await UpdateFooter({ data: payload, id: payload.id, lang: qLang })
          const resData = response.data
          if (resData.status == 202) {
              mAlert.info({
                  title: "Alert",
                  subTitle: "Update Data Success",
                  content: "",
                  onClose: () => {
                    // navigate(`/footer/${qLang}`)
                  },
              })
          }
      }
      catch (err) {
          console.log('err ', err)
          mAlert.info({
              title: "Alert",
              subTitle: "Something went wrong",
              content: "",
              onClose: () => {
              //  alert("onClose")
              },
          })
      }
    }
  }

  // กรณี Edit
  useEffect(() => {
    if (["update", "view"].includes(pageView)) {
      const payload = { id : qMainId }
      API.fetchGetFooterById(payload)
    }
  }, [qLang])

  const PAGE_VIEW = _.capitalize(_.first(pageView) + pageView.slice(1))
  document.title = `Footer | ${PAGE_VIEW} | ` + process.env.REACT_APP_CMS_TITLE

  const itemStyle = {
    padding: '10px',
    border: '1px solid black',
    margin: '5px',
    borderRadius: '8px',
    background: '#f9f9f9',
    transition: 'transform 0.2s ease, background-color 0.3s ease',
  };

  const mapValues = (list = []) => list.map(item => {
    const newObj = {
      attachmentId: item.attachmentId,
      sequence: item.sequence
    }
    return newObj
  })  
  
  if(!checkScope(`${_routePermission}:create`) || !checkScope(`${_routePermission}:update`) || !checkScope(`${_routePermission}:view`)) {
    return <Error401 />
  }

  return (
      <React.Fragment>
          <div className="page-content">
            <Container fluid>
                {/* Render Breadcrumb */}
                <Breadcrumbs
                  title={`${PAGE_VIEW} Footer`}
                  breadcrumbItems={[
                    { title: "Footer", link: "" },
                    { title: PAGE_VIEW },
                  ]}
                />
    
                {/* Render Form */}
                <Row>
                  <Col className="col-12">
                  <FormikProvider value={validation}>
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                      }}
                    >
                      <Row>
                          <Col className="col-8">
                            <Card>
                              <h5 className="card-header bg-transparent border-bottom text-uppercase">
                                <i className='bx bx-cube-alt'></i> Information Box
                              </h5>
                              <CardBody>
                              <Row>
                                <Col className="col-12 mb-3">
                                  <label
                                    htmlFor="category_name"
                                    className="col-md-12 col-form-label"
                                  >
                                    Company Address
                                    <span className="t-require">*</span>
                                  </label>
                                  {/* {JSON.stringify(validation.values.contentCompanyAddress)} */}
                                  <div className="col-md-12">
                                    <MyEditor
                                      onChange={(event, editor) => {
                                        const data = editor.getData()
                                        validation.setFieldValue("contentCompanyAddress", data)
                                      }}
                                      value={validation.values.contentCompanyAddress}
                                      isError={validation.touched.contentCompanyAddress && validation.errors.contentCompanyAddress ? true : false}
                                      disabled={pageView === "view"}
                                    />
                                    { 
                                      validation.touched.contentCompanyAddress && validation.errors.contentCompanyAddress && (
                                        <div type="invalid"className="invalid-feedback d-block">
                                          {validation.errors.contentCompanyAddress}
                                        </div>
                                      )
                                    }
                                  </div>
                                </Col>
                                {/* {validation.values.contentSectionLink1} */}
                                {/* {JSON.stringify(validation.values.contentSectionLink1)} */}
                                <Col className="col-12 mb-3">
                                  <label
                                    htmlFor="category_name"
                                    className="col-md-12 col-form-label"
                                  >
                                    Section Link 1
                                    <span className="t-require">*</span>
                                  </label>
                                  <div className="col-md-12">
                                    <MyEditor
                                      onChange={(event, editor) => {
                                        const data = editor.getData()
                                        validation.setFieldValue("contentSectionLink1", data)
                                      }}
                                      value={validation.values.contentSectionLink1}
                                      isError={validation.touched.contentSectionLink1 && validation.errors.contentSectionLink1 ? true : false}
                                      disabled={pageView === "view"}
                                    />
                                    { 
                                      validation.touched.contentSectionLink1 && validation.errors.contentSectionLink1 && (
                                        <div type="invalid"className="invalid-feedback d-block">
                                          {validation.errors.contentSectionLink1}
                                        </div>
                                      )
                                    }
                                  </div>
                                </Col>
                                <Col className="col-12 mb-3">
                                  <label
                                    htmlFor="category_name"
                                    className="col-md-12 col-form-label"
                                  >
                                    Section Link 2
                                    <span className="t-require">*</span>
                                  </label>
                                  <div className="col-md-12">
                                    <MyEditor
                                      onChange={(event, editor) => {
                                        const data = editor.getData()
                                        validation.setFieldValue("contentSectionLink2", data)
                                      }}
                                      value={validation.values.contentSectionLink2}
                                      isError={validation.touched.contentSectionLink2 && validation.errors.contentSectionLink2 ? true : false}
                                      disabled={pageView === "view"}
                                    />
                                    { 
                                      validation.touched.contentSectionLink2 && validation.errors.contentSectionLink2 && (
                                        <div type="invalid"className="invalid-feedback d-block">
                                          {validation.errors.contentSectionLink2}
                                        </div>
                                      )
                                    }
                                  </div>
                                </Col>
                                <Col className="col-12 mb-3">
                                  <label
                                    htmlFor="category_name"
                                    className="col-md-12 col-form-label"
                                  >
                                    Discover more
                                    <span className="t-require">*</span>
                                  </label>
                                  <div className="col-md-12">
                                    <MyEditor
                                      onChange={(event, editor) => {
                                        const data = editor.getData()
                                        validation.setFieldValue("contentSectionLink3", data)
                                      }}
                                      value={validation.values.contentSectionLink3}
                                      isError={validation.touched.contentSectionLink3 && validation.errors.contentSectionLink3 ? true : false}
                                      disabled={pageView === "view"}
                                    />
                                    { 
                                      validation.touched.contentSectionLink3 && validation.errors.contentSectionLink3 && (
                                        <div type="invalid"className="invalid-feedback d-block">
                                          {validation.errors.contentSectionLink3}
                                        </div>
                                      )
                                    }
                                  </div>
                                </Col>
                              </Row>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col className="col-4">
                            <Card outline color="primary" className="border sticky-element">
                                <h5 className="card-header bg-transparent border-bottom text-primary text-uppercase">
                                  <i className='bx bx-check'></i> Tools Box
                                </h5>
                                <CardBody>
                                  <Row>
                                    <Col className="col-12 mb-3">
                                      <label
                                        htmlFor="category_name"
                                        className="col-md-12 col-form-label"
                                      >
                                        Switch Language
                                        <span className="t-require">*</span>
                                      </label>
                                      <div className="col-md-12">
                                        <InputLang widthfull pageView={pageView} forceRoute={false}/>
                                      </div>
                                    </Col>
                                    <Col className="col-12 mb-3">
                                      <label
                                        htmlFor="category_name"
                                        className="col-md-12 col-form-label"
                                      >
                                        Written at
                                        <span className="t-require">*</span>
                                      </label>
                                      <div className="col-md-12">
                                        <InputGroup>
                                          <Flatpickr
                                            className="form-control d-block"
                                            options={{
                                              dateFormat: 'd/m/Y', // กำหนดรูปแบบวันที่ เช่น 15/08/1997
                                            }}
                                            value={validation.values.contentUpdateDate  ?moment(validation.values.contentUpdateDate, 'YYYY-MM-DD').toDate() : null}
                                            disabled={true}
                                          />
                                          <div className="input-group-append">
                                            <button
                                              type="button"
                                              className="btn btn-outline-secondary docs-datepicker-trigger"
                                              disabled
                                            >
                                              <i className="fa fa-calendar" aria-hidden="true"/>
                                            </button>
                                          </div>
                                        </InputGroup>
                                        {
                                          (validation.touched.contentUpdateDate && validation.errors.contentUpdateDate) && (
                                            <div type="invalid" className="invalid-feedback d-block">{validation.errors.contentUpdateDate}</div>
                                          )
                                        }
                                      </div>
                                    </Col>
                                    <Col className="col-12 mb-3">
                                      <label
                                        htmlFor="category_name"
                                        className="col-md-12 col-form-label"
                                      >
                                        Display
                                        <span className="t-require">*</span>
                                      </label>
                                      <div className="col-md-12">
                                        <Select
                                          placeholder="Select Status"
                                          value={fn_helper.FNFORM.getObjectValue(STATUS_OPTION, `${validation.values.contentStatus}`)}
                                          onChange={(value) => validation.setFieldValue("contentStatus", value.id)}
                                          getOptionValue={(option) => option.id}
                                          getOptionLabel={(option) => option.name}
                                          options={STATUS_OPTION}
                                          className={`select2-selection ${validation.touched.contentStatus && validation.errors.contentStatus ? "input-err" : ""}` }
                                          isDisabled={pageView === "view" || true}
                                        />
                                        {
                                          (validation.touched.contentStatus && validation.errors.contentStatus) && (
                                            <div type="invalid" className="invalid-feedback d-block">{validation.errors.contentStatus}</div>
                                          )
                                        }
                                      </div>
                                    </Col>
                                  </Row>
                                </CardBody>
                                <CardFooter>
                                  <Row>
                                      {/* <Col className="text-start">
                                          <Button color="danger" className="btn btn-danger" onClick={() => navigate(`/footer/${qLang}`)}>Back</Button> 
                                      </Col> */}
                                      <Col className="text-end">
                                        {pageView !== 'view' && (<Button type="submit" className="btn btn-success">Save</Button>)}
                                      </Col>
                                  </Row>
                                </CardFooter>
                            </Card>
                          </Col>
                          <Col className="col-12">
                            <Card>
                                <h5 className="card-header bg-transparent border-bottom text-uppercase">
                                    <i className='bx bx-trending-up'></i> Social Link
                                </h5>
                                <CardBody>
                                  <Row>
                                    <Col className="col-12 mb-3">
                                    {/* {JSON.stringify(validation.values.socialLink)} */}
                                      <div className="col-md-12">
                                        <UploadDesc
                                          upload="Image"
                                          typeUpload="ImageMap"
                                          label="Social Link"
                                          required={true}
                                          widthSize={35}
                                          heightSize={35}
                                          description="description"
                                        />
                                        <section className="b-upload-list">
                                          <ReactSortable
                                            list={validation.values.socialLink} // ผูกข้อมูลกับค่าใน Formik
                                            setList={(newState) => {
                                              console.log('สถานะใหม่:', newState);
                                              const newStateSort = fn_helper.FNFORM.setReSequence(newState)
                                              validation.setFieldValue('socialLink', newStateSort); // อัพเดตค่าฟอร์ม
                                            }}
                                            animation={200}
                                            handle=".drag-handle" // จุดที่สามารถลากได้
                                            onEnd={() => {
                                              console.log('ลากและปล่อยเสร็จสิ้น');
                                              // validation.validateField('socialLink'); // ตรวจสอบความถูกต้องของฟิลด์
                                            }}
                                          >
                                            <FieldArray name="socialLink">
                                              {({ push, remove }) => (
                                                <>
                                                  {
                                                    validation.values.socialLink.map((row, index) => {
                                                      return (
                                                        <div className="drag-handle" key={index}>
                                                          <PopupAttachment
                                                            isShowLabel={false}
                                                            typeDetail="muti"
                                                            typeUpload="ImageMap"
                                                            upload="Image"
                                                            prefixName="brand-image"
                                                            label="Social Link"
                                                            required={true}
                                                            description="description"
                                                            widthSize={35}
                                                            heightSize={35}
                                                            value={row}
                                                            index={index}
                                                            mode="ImageLink"
                                                            onChange={(value = {}, index) => {
                                                              console.log("🚀 onChange ~ value:", value)
                                                              console.log("🚀 onChange ~ index:", index)
                                                              const name = `socialLink.${index}`
                                                              validation.setFieldValue(name, value)
                                                              // customHandleChange(e, index)
                                                              // push(value)
                                                            }}
                                                            onRemove={(index) => {
                                                              console.log("🚀 onChange ~ index:", index)
                                                              remove(index)
                                                            }}
                                                          />
                                                        </div>
                                                      )
                                                    })
                                                  }
                                                  <PopupAttachment
                                                    isAddMode={true}
                                                    isShowLabel={false}
                                                    typeDetail="muti"
                                                    typeUpload="ImageMap"
                                                    upload="Image"
                                                    prefixName="brand-image"
                                                    label="Social Link"
                                                    required={true}
                                                    description="description"
                                                    widthSize={35}
                                                    heightSize={35}
                                                    index={validation.values.socialLink.length}
                                                    // mode="ImageLink"
                                                    mode="ImageLink"
                                                    onChange={(value = {}, index) => {
                                                      console.log("🚀 onChange ~ value:", value)
                                                      console.log("🚀 onChange ~ index:", index)
                                                      push(value)
                                                    }}
                                                    onRemove={(index) => {
                                                      console.log("🚀 onChange ~ index:", index)
                                                      remove(index)
                                                    }}
                                                  />
                                                </>
                                              )}
                                            </FieldArray>
                                          </ReactSortable>
                                        </section>

                                      </div>
                                      <hr/>
                                    </Col>
                                  </Row>
                                </CardBody>
                            </Card>
                          </Col>
                      </Row>
                    </Form>
                  </FormikProvider>
                  </Col>
                </Row>
            </Container>
          </div>
      </React.Fragment>
  )
}

// QuestionaireCategory.propTypes = {
//     t: PropTypes.any,
// };

export default withTranslation()(FooterTemplate)
